module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0082.jpg?v=7f2a5eae";